import { ajaxSend } from '../../../api/api';
const v2BasePath = '/v2/queues';
const v3BasePath = '/v3/queues';
export function getQueues(params = {}) {
    return ajaxSend({
        path: v3BasePath,
        params: params,
    });
}
export function getQueue(queueId) {
    return ajaxSend({
        path: `${v2BasePath}/${queueId}`,
    });
}
export function createQueue(data) {
    return ajaxSend({
        method: 'POST',
        path: `${v2BasePath}`,
        data,
    });
}
export function updateQueue(queueId, data) {
    return ajaxSend({
        method: 'PATCH',
        path: `${v2BasePath}/${queueId}`,
        data,
    });
}
